import {
  deleteEndpointPoliciesId,
  postEndpointPolicies,
  putEndpointPoliciesId,
  useGetEndpointPolicies,
} from '@ipfabric/api-client/client/model/rbac-—-endpoint-policies/rbac-—-endpoint-policies';
import type {
  GetEndpointPolicies200Item,
  PostEndpointPoliciesBody,
} from '@ipfabric/api-client/client/schemas';
import { useStableCallback } from '@ipfabric/ui-components/hooks/useStableCallback';
import { useQueryClient } from '@tanstack/react-query';

export type EndpointPolicy = GetEndpointPolicies200Item;
export type EndpointPolicyBody = PostEndpointPoliciesBody;

export const useEndpointPoliciesQuery = () => useGetEndpointPolicies();

export const useEndpointPoliciesApi = () => {
  const queryClient = useQueryClient();
  const invalidate = useStableCallback(() =>
    queryClient.invalidateQueries({ queryKey: ['/endpoint-policies'] }),
  );

  const createEndpointPolicy = useStableCallback(
    async (body: EndpointPolicyBody) => {
      await postEndpointPolicies(body);
      await invalidate();
    },
  );

  const updateEndpointPolicy = useStableCallback(
    async (id: string, body: EndpointPolicyBody) => {
      await putEndpointPoliciesId(id, body);
      await invalidate();
    },
  );

  const deleteEndpointPolicy = useStableCallback(async (id: string) => {
    await deleteEndpointPoliciesId(id);
    await invalidate();
  });

  return { createEndpointPolicy, updateEndpointPolicy, deleteEndpointPolicy };
};
